// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lvgC","colBig":"styles_colBig__2BMCe","colSmall":"styles_colSmall__37QvA"};